import axios from 'axios'
import ElementUI from 'element-ui'
import router, { resetRouter } from '@/router'

const request = axios.create({
  // baseURL: 'http://localhost:8082', // 开发环境 // 注意！！ 这里是全局统一加上了 '/api' 前缀，也就是说所有接口都会加上'/api'前缀在，页面里面写接口的时候就不要加 '/api'了，否则会出现2个'/api'，类似 '/api/api/user'这样的报错，切记！！！
  // baseURL: 'http://wy.taolemon.com:8073/propMan/', // 测试环境
  baseURL: 'https://taolemon.com/propMan/', // 生产环境
  timeout: 5000
})

// request 拦截器
// 可以自请求发送前对请求做一些处理
// 比如统一加token，对请求参数统一加密
request.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/json;charset=utf-8'

  const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null
  if (user) {
    config.headers.token = user.token // 设置请求头
  }

  return config
}, error => {
  return Promise.reject(error)
})

// response 拦截器
// 可以在接口响应后统一处理结果
request.interceptors.response.use(
  response => {
    let res = response.data
    // 如果是返回的文件
    if (response.config.responseType === 'blob') {
      return res
    }
    // 兼容服务端返回的字符串数据
    if (typeof res === 'string') {
      res = res ? JSON.parse(res) : res
    }
    // token验证不通过给出提示
    if (res.code === 401) {
      if (res.msg === '无token，请重新登录') {
        router.push('/login')
        localStorage.removeItem('user')
        localStorage.removeItem('currentUser')
        localStorage.removeItem('menus')
        // 重置路由
        resetRouter()
      }
      ElementUI.Message({
        message: res.msg,
        type: 'error'
      })
    }
    return res
  },
  error => {
    console.log('err' + error) // for debug
    return Promise.reject('error')
  }
)

export default request
